import { gql }          from '@apollo/client';
// import {graphql} from '../client';

export const GQL_QUERY_GET_STUDENT = gql`
  query getStudent ($id: ID!) {
    getStudent(id: $id) {
      id

      lastName
      firstName
      ucinetid

      createdAt
      updatedAt
    }
  }
`;


export const GQL_QUERY_LIST_STUDENTS = gql`
  query listStudents ($filter: StudentFilterInput, $sort: SortInput, $page: PaginationInput) {
    listStudents(filter: $filter, sort: $sort, page: $page) {
      items {
        id

        lastName
        firstName
        ucinetid

        createdAt
        updatedAt
      }
      meta {
        count
        pages
      }
    }
  }
`;
